import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import api from '../services/api'
import { useStore } from '../stores/useStore'
import { Eye, EyeOff } from 'lucide-react'

export default function Login() {
  const navigate = useNavigate()
  const { setToken, setUser } = useStore()

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await api.post('/auth/login', formData)

      setToken(response.data.token)
      setUser(response.data.user)

      navigate('/dashboard')
    } catch (err) {
      const apiError = err.response?.data?.error || 'Error al iniciar sesión'
      const apiCode = err.response?.data?.code
      setError(apiError)
      if (apiCode === 'EMAIL_NOT_CONFIRMED' && formData.email) {
        navigate(`/verify-email?email=${encodeURIComponent(formData.email)}`)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-game-dark">
      <div className="max-w-md w-full p-8 bg-gray-900 rounded-lg shadow-xl border border-gray-800">
        {/* Título del juego */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-game-primary">TerranWar</h1>
          <p className="text-sm text-gray-400 mt-1">Proyecto-V</p>
        </div>

        <h2 className="text-xl text-center text-gray-300 mb-6">Iniciar Sesión</h2>

        {error && (
          <div className="mb-4 p-3 bg-red-900/50 border border-red-500 rounded-lg text-red-200 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-game-primary"
              placeholder="tu@email.com"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2 pr-10 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-game-primary"
                placeholder="••••••••"
                required
                disabled={loading}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-game-primary transition-colors"
                disabled={loading}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-game-primary text-game-dark font-bold py-2 px-4 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Iniciando sesión...' : 'Jugar'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/register" className="text-game-primary hover:underline">
            ¿No tienes cuenta? Regístrate
          </Link>
          <div className="mt-2">
            <Link to={`/verify-email${formData.email ? `?email=${encodeURIComponent(formData.email)}` : ''}`} className="text-gray-300 hover:text-game-primary underline">
              Tengo código de verificación
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
